<script lang="ts">
	import { userInfo } from '../../stores';
	import DuplicateForm from '../../components/Segments/Duplicate/DuplicateForm.svelte';
	import AppContainer from '../../components/AppContainer.svelte';

	export let id: string;

	let isClientDentsuCZ = false;
	$: {
		if ($userInfo.client !== undefined) {
			isClientDentsuCZ = $userInfo.client.id === '1' || $userInfo.client.id === '7';
		}
	}
</script>

<AppContainer fluid>
	<svelte:component this={DuplicateForm} {id} isDentsu={isClientDentsuCZ} />
</AppContainer>
